<template>
  <report-section
    :is-loading="isLoadingReport"
    :title="$i18nPresenter.t('Most engaging slides')"
    :tooltip="$i18nPresenter.t('Your top 3 slides that received the most interactions.')"
  >
    <div class="tes-slider __slider">
      <div v-if="!isLoadingReport">
        <div class="tes-slider __prev">
          <aha-icon name="arrow-no-tail" class="transform rotate-180" />
        </div>
        <div class="tes-slider __next">
          <aha-icon name="arrow-no-tail" />
        </div>
        <swiper
          ref="mySwiper"
          v-if="mostEngagingSlides && mostEngagingSlides.length"
          :options="swiperOptions"
        >
          <swiper-slide
            v-for="(slide) in mostEngagingSlides"
            :key="slide.id"
          >
            <slide-card
              class="p-3"
              :slide="slide"
              :loading="isLoadingReport"
            >
              <span
                class="flex items-center mr-6 cursor-pointer"
                v-tooltip="responseCountTooltip"
              >
                <span
                  class="inline-flex items-center justify-center w-4 h-4 mr-1 rounded-full bg-secondary-15"
                >
                  <aha-icon
                    name="chat"
                    class="text-secondary-50"
                    width="12"
                    height="12"
                    viewBox="0 0 14 15"
                  />
                </span>
                <span class="text-xs text-base-80">{{ slide.responseCount }}</span>

              </span>
              <!-- AHA-6606: set min-w to avoid shrinking on small real devices -->
              <Reactions
                class="flex flex-shrink-0 cursor-pointer sm:block min-w-12 sm:min-w-none"
                :presentation="{
                  reactions: selectedPresentation.reactions,
                  numberOfLikes: slide.reactions.like || 0,
                  numberOfHearts: slide.reactions.heart || 0,
                  numberOfLaughs: slide.reactions.laugh || 0,
                  numberOfWows: slide.reactions.wow || 0,
                  numberOfSads: slide.reactions.sad || 0,
                }"
              />
            </slide-card>
          </swiper-slide>
        </swiper>
      </div>
      <div v-else>
        <slide-card
          class="p-3"
          is-loading
        />
      </div>
    </div>
  </report-section>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import ReportSection from '@/components-v2/presentation-report/ReportSection.vue'
import SlideCard from '@/components-v2/presentation-report/SlideCard.vue'
import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    ReportSection,
    SlideCard,
    Reactions,
    Swiper,
    SwiperSlide,
  },
  props: {},
  data: () => ({
    swiperOptions: {
      slidesPerView: 1,
      navigation: {
        prevEl: '.tes-slider.__prev',
        nextEl: '.tes-slider.__next',
      },
    },
  }),
  computed: {
    ...mapGetters('presentationReport', ['mostEngagingSlides', 'selectedPresentation', 'isLoadingReport']),
    responseCountTooltip() {
      return {
        content: this.$i18nPresenter.t("An 'interaction' is any of these actions from a participant:<br/> - A Q&A question<br/> - A submitted response."),
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.tes-slider {
  &.__slider {
    @apply relative rounded-lg;
    box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  }

  &.__prev,
  &.__next {
    @apply absolute cursor-pointer bg-base-0 rounded-lg w-4 h-4 z-5;
    @apply flex justify-center items-center hover:text-primary-100;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    top: 40%;
    &.swiper-button-disabled {
      @apply hidden;
    }
  }

  &.__prev {
    left: -8px;
  }

  &.__next {
    right: -8px;
  }
}
</style>
